import EA from 'helpers/init';

export default EA.Methods.footerDarkBg = ($this) => {
    const sections = document.querySelectorAll('section');
    const footer = document.querySelector('footer');

    if (sections.length > 0 && footer) {
        const lastSection = sections[sections.length - 1];

        if (lastSection.classList.contains('bg-dark')) {
            footer.classList.add('bg-dark');
        }
    }
};